module.exports = __webpack_public_path__ + "static/pic9-2b30cb80e2cb2d2d085f0c2ba0b84353.jpg";